import { Component, OnDestroy, OnInit, forwardRef, Inject, Input, inject, AfterViewInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { BeneficiaryListTableEditComponent } from '../../beneficiary-list-table-edit.component';
import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { Subscription } from 'rxjs';
import { CommonDataService } from '@infrastructure/CommonData/CommonDataService';
import { WorkflowComponentNew } from '../../../../workflow-new.component';
import { DomainCodes } from '../../../../../../models/const.DomainCodes';
import { DropdownsValues } from '@infrastructure/Dropdowns/const.dropdowns';
import DateHelpers from '@infrastructure/DateHelpers';
import { isNotNullOrUndefinedOrEmpty } from '@infrastructure/objectUtils';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';
import { LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';


@Component({
  selector: 'deceased-relationship',
  templateUrl: './deceased-relationship.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListTableEditComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class DeceasedRelationshipComponent extends TableEditBase<models.BeneficiaryVM> implements OnInit, OnDestroy {

  public deceasedRelationshipValues = DropdownsValues.dropdownDeceasedRelationship;
  scholarSituationDeathDateValues = DropdownsValues.dropListScholarSituationDeathDate;
  @Input("cardData")
  public cardData: models.DeceasedRelationshipVM = {} as models.DeceasedRelationshipVM;



  @Input("hasLegalRepresentation")
  public hasLegalRepresentation: boolean;

  @Input("stateRL")
  public stateRL: number;

  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  //@CommonData(DomainCodes.country)
  public relations: models.DimensionVM[];
  //@CommonData(DomainCodes.country)
  public scholarSituation: models.DimensionVM[];
  @CommonData(DomainCodes.studyLevel)
  public educationLevel: models.DimensionVM[];

  public dropListDeceasedRelationship: models.Options[] = [];

  public dropListScholarSituationDeathDate: models.Options[] = [];

  public dropdownEducationLevelTOD: models.Options[] = [];

  public minDate: Date = new Date(1900, 0, 1);
  public maxDate: Date = new Date();


  @Input("benefitType")
  public benefitType: models.BenefitTypeVM;

  @Input("beneficiaryIdentification")
  public beneficiaryIdentification: models.BeneficiaryIdentificationVM;

  public mainSubscription: Subscription = new Subscription();
  public isCommonDataLoaded: boolean = false;
  controlContainer: ControlContainer;
  constructor(@Inject(BeneficiaryListTableEditComponent) public parent: Component,
    private modalService: ModalService,
    private commonDataService: CommonDataService,
    private beneficiariesStateService: LegalRepresentationStateService) {
    super(parent, modalService);
    this.cardData = (<any>parent)._cardData;
    const domains = [
      DomainCodes.yesNo,
      DomainCodes.studyLevel
    ];

    this.mainSubscription.add(
      this.commonDataService.getDomains(domains).subscribe(
        (results: models.DomainVM[]) => {
          this.yesNo = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.yesNo).dimensions;
          this.educationLevel = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.studyLevel).dimensions;
          this.isCommonDataLoaded = true;
        }
      )
    );
    this.controlContainer = inject(ControlContainer);
  }


  public parentWorkflow: WorkflowComponentNew;

  public anoAtual : number = new Date().getFullYear();

  ngOnInit(): void {
    this.dropListDeceasedRelationship = (this.parent as BeneficiaryListTableEditComponent).dropdowns.options
      .filter(el => el.dropdown === "DropdownDeceasedRelationship");

    this.dropListScholarSituationDeathDate = (this.parent as BeneficiaryListTableEditComponent).dropdowns.options
      .filter(el => el.dropdown === "dropListScholarSituationDeathDate");

    this.dropdownEducationLevelTOD = (this.parent as BeneficiaryListTableEditComponent).dropdowns.options
      .filter(el => el.dropdown === "DropdownEducationLevelTOD");

    
  }



  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
  }


  capitalize(value: string) {
    this.cardData[value] = this.cardData[value].toUpperCase();
  }
  
  calculaMaiorIdade() {
    return DateHelpers.isAdult(this.beneficiaryIdentification.dateOfBirth);
    
  }

  public scholarSituationDeathDateRequired():boolean {
    const filhosEMaiorDeidade = this.cardData.deceasedRelationship === this.deceasedRelationshipValues.Filhos &&
      this.calculaMaiorIdade();

    const netos = this.cardData.deceasedRelationship === this.deceasedRelationshipValues.Netos;
    const encontraCargo = this.cardData.hasChargeDeceased?.toString() == 'true';

    const enteando = this.cardData.deceasedRelationship === this.deceasedRelationshipValues.Enteado;

    const result = (netos && encontraCargo) || (enteando && encontraCargo) || filhosEMaiorDeidade;
    return result;
   
  }

  public activeProfessionalSituationRequired(): boolean {
    if (this.benefitType.funeralAllowanceBenefit?.toString() != "true" && this.benefitType.survivalPensionBenefit?.toString() != "true" ) {
      const beneficiosRequidos = this.benefitType.survivalPensionBenefit?.toString() === 'true' ||
        this.benefitType.funeralAllowanceBenefit?.toString() === 'true';
      const filhosEMaiorDeidade = this.cardData.deceasedRelationship === this.deceasedRelationshipValues.Filhos &&
        this.calculaMaiorIdade();
      const netos = this.cardData.deceasedRelationship === this.deceasedRelationshipValues.Netos;
      const result = beneficiosRequidos && (filhosEMaiorDeidade || netos);
      return result;
    } else {
      const netos = this.cardData.deceasedRelationship === this.deceasedRelationshipValues.Netos;
      const result = netos && this.cardData.hasChargeDeceased?.toString() == 'false';
    }
  }

  public isDiferentDeColocado(): boolean {
    let result = isNotNullOrUndefinedOrEmpty(this.cardData.scholarSituationDeathDate);
    result = result && this.cardData.scholarSituationDeathDate != this.scholarSituationDeathDateValues.NaoColocado;
    return result;
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    var object

    switch (event.target.name) {
      case 'startDateCohabitation': {
        object = new Date(this.cardData.startDateCohabitation).toISOString().split('T')[0];
        break;
      }
      case 'marriageDate': {
        object = new Date(this.cardData.marriageDate).toISOString().split('T')[0];
        break;
      }
      case 'startDateProfession': {
        object = new Date(this.cardData.startDateProfession).toISOString().split('T')[0];
        break;
      }
      case 'socialPensionDate': {
        object = new Date(this.cardData.socialPensionDate).toISOString().split('T')[0];
        break;
      }
    }

    DateHelpers.onDateChange(event, dp, object);
  }

  public isNotStateRLDiferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateDeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return !result;
  }

  public IsStateIndeferida(): boolean {
    const result = this.beneficiariesStateService
      .getStateIndeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return !result;
  }

  public isFilhoOuEnteado(): boolean {
    const result = this.cardData.deceasedRelationship === this.deceasedRelationshipValues.Enteado ||
      this.cardData.deceasedRelationship === this.deceasedRelationshipValues.Netos;
    return result;
  }

  public isPaisOuAvos(): boolean {
    const result = this.cardData.deceasedRelationship === this.deceasedRelationshipValues.Pais ||
      this.cardData.deceasedRelationship === this.deceasedRelationshipValues.Avos;
    return result;
  }

  public isNotSurvivalPensionOrSM(): boolean {
    const result = this.benefitType.funeralAllowanceBenefit?.toString() == 'true' ||
      this.benefitType.survivalPensionBenefit?.toString() == 'true';
    return !result;
  }
}
